import React from 'react'
import { connect } from 'react-redux'
import ShopInfo from './shopinfo.react.js'

const mapStateToProps = (state) => {
  return {
    shops: state.shops,
  }
}

const mapDispatchToProps = {
}

const ShopList = React.createClass({
  getInitialState: function() {
    return {
      showLoginOrRegister: false,
    }
  },

  render: function() {
    return (
      <div>
        {this.props.shops.map((shop, i)=>(
          <ShopInfo shop={shop} key={shop.id}></ShopInfo>
        ))}
      </div>
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopList)



// WEBPACK FOOTER //
// ./components/shoplist.react.js